import { translate, useLocale } from "../../localization";
import React from "react";
import { Box, MenuItem } from "@mui/material";
import { AppTextField } from "../ui";
import {
  createDefaultElementOptimizationForm,
  ELEMENT_OPTIMIZATION_METHOD_OPTIONS,
  ELEMENT_OPTIMIZATION_MODE_OPTIONS,
  getElementOptimizationModeHelperText,
  isCustomElementOptimizationMode,
} from "../../utility/elementOptimization";

const ElementOptimizationFields = ({ optimization, onChange }) => {
  useLocale();
  const value = optimization || createDefaultElementOptimizationForm();

  const updateOptimization = (patch) => {
    onChange?.({
      ...value,
      ...patch,
    });
  };

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", sm: "repeat(2, minmax(0, 1fr))" },
        gap: 1.5,
        minWidth: 240,
      }}
    >
      <AppTextField
        select
        label={translate("Optimization")}
        value={value.mode}
        onChange={(e) => updateOptimization({ mode: e.target.value })}
        helperText={getElementOptimizationModeHelperText(value.mode)}
        fullWidth
        sx={{ gridColumn: { xs: "auto", sm: "1 / -1" } }}
      >
        {ELEMENT_OPTIMIZATION_MODE_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </AppTextField>

      {isCustomElementOptimizationMode(value.mode) && (
        <>
          <AppTextField
            select
            label={translate("Method")}
            value={value.method}
            onChange={(e) => updateOptimization({ method: e.target.value })}
            fullWidth
          >
            {ELEMENT_OPTIMIZATION_METHOD_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </AppTextField>
          <AppTextField
            label={translate("Target Faces")}
            type="number"
            value={value.targetFaces}
            onChange={(e) => updateOptimization({ targetFaces: e.target.value })}
            inputProps={{ min: 1, step: 1000 }}
            helperText={translate("Positive integer face target.")}
            fullWidth
          />
        </>
      )}
    </Box>
  );
};

export default ElementOptimizationFields;
